import React from 'react'

export default function Header() {
    return (
        <div className="text-primary text-center p-10">
            header of page
        </div>
    )
}
